<script>
  import Obs from "./Obs.svelte";
  import TabelaNaoRealizado from "./TabelaNaoRealizado.svelte";

  let dataInicial = new Date().toISOString().split("T")[0];
  let dataFinal = "2025-03-03";
  let numRefeicoes = 6;
  let dias = [];
  let temObservacao = false; // Estado do toggle (inicialmente desligado)

  $: {
    dias = gerarDias(dataInicial, dataFinal, numRefeicoes);
  }

  $: totalSemanas = Math.ceil(dias.length / 7);

  $: totalLinhas = calcularTotalLinhas(totalSemanas);  //Mantive, mas não é mais usado diretamente.

  function calcularTotalLinhas(totalSemanas) {
    // Lógica original (mantida, mas o retorno não é mais usado diretamente)
    const maxLinhas = 5;
    const minLinhas = 1;
    if (totalSemanas <= 9) {      return maxLinhas;    }
    else if (totalSemanas <= 18) {      return maxLinhas - 1;    }
    else if (totalSemanas <= 27) {      return maxLinhas - 2;    }
    else if (totalSemanas <= 36) {      return maxLinhas - 3;    }
    else if (totalSemanas <= 45) {      return maxLinhas - 4;    }
    return minLinhas;
  }

  function gerarDias(dataInicial, dataFinal, numRefeicoes) {
    const dataInicialTimestamp = new Date(dataInicial).getTime();
    const dataFinalTimestamp = new Date(dataFinal).getTime();
    const primeiroDiaSemana = new Date(dataInicial).getDay();
    const dias = [];

    for (let i = 0; i < primeiroDiaSemana; i++) {
      dias.push({ vazio: true });
    }

    let diaAtualTimestamp = dataInicialTimestamp;
    while (diaAtualTimestamp <= dataFinalTimestamp) {
      const dia = new Date(diaAtualTimestamp).getDate();
      const mes = new Date(diaAtualTimestamp).getMonth() + 1;
      const ano = new Date(diaAtualTimestamp).getFullYear();
      const diaSemana = new Date(diaAtualTimestamp).getDay();
      const hoje = new Date().toDateString() === new Date(diaAtualTimestamp).toDateString();

      dias.push({
        vazio: false,
        dia,
        mes,
        ano,
        diaSemana,
        hoje,
        bolinhas: Array.from({ length: numRefeicoes }, (_, i) => i + 1),
        bolinhasVazias: Array.from({ length: 6 - numRefeicoes }, () => null),
      });

      diaAtualTimestamp += 86400000;
    }

    const ultimoDiaSemana = new Date(dataFinal).getDay();
    for (let i = ultimoDiaSemana; i < 6; i++) {
      dias.push({ vazio: true });
    }

    return dias;
  }


</script>

<img src="./img/barrainferior.webp" alt="barra" class="barra2" onerror="this.onerror=null;this.src='./img/barrainferior.png'" />
<div class="principal">
  <div id="cabecalho-original">
    <img src="img/logo2.webp" alt="Logo" class="logo" onerror="this.onerror=null;this.src='img/logo2.png'" />
    <img class="barra-verde" src="./img/barra.webp" alt="Imagem" onerror="this.onerror=null;this.src='./img/barra.png'" />
    <img src="./img/marca.webp" alt="Imagem" class="imagem-fixa" onerror="this.onerror=null;this.src='./img/marca.png'" />
  </div>

  <div class="input-container nao-imprimir">
    <label for="dataInicial">Data Inicial:</label>
    <input type="date" id="dataInicial" bind:value={dataInicial} />

    <label for="dataFinal">Data Final:</label>
    <input type="date" id="dataFinal" bind:value={dataFinal} />

    <label for="numRefeicoes">Refeições por dia:</label>
    <input
      type="number"
      id="numRefeicoes"
      bind:value={numRefeicoes}
      min="1"
      max="6"
    />
  </div>
 <!-- Toggle para Observações -->
    <div class="toggle-container nao-imprimir">
      <label>
        <input type="checkbox" bind:checked={temObservacao} />
        Mostrar Observações
      </label>
    </div>
  <h3>Mapa do sucesso</h3>

  <div class="espacar">
    <p>
      "Seu sucesso começa aqui! Marque um X para cada refeição que você seguiu
      conforme as orientações. Cada marca representa seu comprometimento com sua
      saúde e bem-estar. Continue firme, você consegue!
    </p>

    {#each Array.from({ length: Math.ceil(dias.length / 63) }) as _, groupIndex}
      <div class="calendario-secao">
        {#if groupIndex > 0}
          <div class="cabecalho-pagina">
            <br />
            <img src="img/logo2.webp" alt="Logo" class="logo-impressao" onerror="this.onerror=null;this.src='img/logo2.png'" /><br />
          </div>
        {/if}
        <table id="calendario">
          <thead>
            <tr>
              <th>Dom</th>
              <th>Seg</th>
              <th>Ter</th>
              <th>Qua</th>
              <th>Qui</th>
              <th>Sex</th>
              <th>Sáb</th>
            </tr>
          </thead>

          {#each Array.from({ length: 9 }) as _, rowIndex}
            {#if rowIndex + groupIndex * 9 < Math.ceil(dias.length / 7)}
              <tr>
                {#each dias.slice((rowIndex + groupIndex * 9) * 7, (rowIndex + groupIndex * 9 + 1) * 7) as dia}
                  {#if dia.vazio}
                    <td />
                  {:else}
                    <td class:hoje={dia.hoje}>
                      <span class="dia">{dia.dia}/{dia.mes}</span>
                      <div class="bolinhas-container">
                        {#each dia.bolinhas as bolinha}
                          <span class="bolinha">{bolinha}</span>
                        {/each}
                        {#each dia.bolinhasVazias as bolinhaVazia}
                          <span class="bolinha-vazia"> </span>
                        {/each}
                      </div>
                    </td>
                  {/if}
                {/each}
              </tr>
            {/if}
          {/each}
        </table>
      </div>
    {/each}

    

    {#if temObservacao}
      <Obs />  <!--  totalLinhas não é mais passado -->
    {/if}

  </div>
</div>

<div style="page-break-after: always;"></div>
<TabelaNaoRealizado />

<style>
  /* Estilos (mantidos e com adição do toggle) */
  body {
    background-color: white;
  }

  .espacar {
    margin-left: 30px;
    margin-right: 30px;
  }

  @font-face {
    font-family: "Century Gothic";
    src: url("/centurygothic.woff2") format("woff2");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  h3 {
    font-family: "Century Gothic", sans-serif;
    font-size: 32px;
    color: #938e6d;
    text-align: center;
  }

  .principal {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    font-family: "Century Gothic", sans-serif;
  }

  .calendario-secao {
    page-break-inside: avoid;

    border-radius: 20px;
    border: 2px solid #938e6d;
    padding: 15px;
    background-color: transparent;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }

  table {
    border-collapse: separate;
    border-spacing: 5px;
    font-family: sans-serif;
    background-color: #ffffff;
  }

  th {
    height: 20px;
    padding: 2px;
    font-size: 12px;
    text-align: center;
    vertical-align: top;
    width: 14.28%;
  }

  td {
    text-align: center;
    vertical-align: top;
    width: 5px;
    height: 100px;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border: 2px solid #e8f0fe;
  }

  .hoje {
    background-color: #e8f0fe;
  }

  .dia {
    font-weight: bold;
    font-size: 18px;
    display: block;
    margin-bottom: 5px;
  }

  .bolinhas-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1px;
  }

  .bolinha {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: transparent;
    border: 2px solid #a1b57d;
    color: black;
    text-align: center;
    line-height: 20px;
    margin: 2px;
  }

  .bolinha-vazia {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: transparent;
    border: transparent;
    color: white;
    text-align: center;
    line-height: 20px;
    margin: 2px;
  }

  .barra2 {
    display: block;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
  }

  .barra-verde {
    display: block;
    position: fixed;
    top: 0px;
    width: 100%;
    height: auto;
    z-index: 5;
  }
  #calendario {
    width: 100%;
    margin: auto;
  }
  /* Estilos para impressão */
  @media print {
    .barra2 {
      display: block;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 1;
    }

    .logo-impressao {
      display: block;
      margin: 0 auto;
      width: 180px;
      padding-top: 10px;
    }

    .cabecalho-pagina {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      page-break-inside: avoid;
    }

    .calendario-secao {
      position: relative;
      border-radius: 20px;
      border: 2px solid#a1b57d;
      padding: 15px;
      background-color: white;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

      margin-bottom: 20px;
    }

    .imagem-fixa {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50%;
      height: auto;
      opacity: 0.4;
      z-index: 5;
    }

    .nao-imprimir {
      display: none;
    }

    #calendario {
      width: auto;
      margin: auto;
    }
    table {
      width: auto;
      margin: 0 auto;
    }
    td {
      text-align: center;
      vertical-align: top;
      width: 14%;
      height: 100px;
      border-radius: 10px;
      background-color: white;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
      border: 2px solid #a1b57d;
    }
  }

  .logo {
    display: flex;
    justify-content: center;
    width: 180px;
    margin: 0 auto;
    margin-top: 25px;
  }

  .input-container {
    margin-bottom: 20px;
  }

  .input-container label {
    margin-right: 10px;
  }

    /* Estilos para o toggle */
  .toggle-container {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    text-align: center; /* Centraliza o toggle */
  }

  .toggle-container label {
    display: inline-flex; /* Para alinhar o checkbox e o texto */
    align-items: center; /* Alinha verticalmente */
    cursor: pointer;
    gap: 0.5rem; /* Espaço entre o checkbox e o texto */
  }

  @media screen {
    .imagem-fixa {
      display: none;
    }
  }
</style>